import { includes, map, replace, sortBy } from "lodash";
import React from "react";
import { Container } from "react-bootstrap";
import { useGetLocalText } from "../../utils";
import translationText from "../../translation.js";
import useGetResponse from "../../apis/useGetResponse";
import Page from "../../common/component/fragments/Page";

const isTitle = (str) => !includes(str, "•");

const RenderMission = ({ data }) => {
  const { msg1, msg2, msg3 } = useGetLocalText(data, ["msg1", "msg2", "msg3"]);
  const hasTitle = isTitle(msg1);

  return (
    <>
      {hasTitle && (
        <h2
          style={{
            color: "#FAA652",
          }}
        >
          {msg1}
        </h2>
      )}
      <ul>
        {!hasTitle && msg1 && <li>{replace(msg1, "•", "")}</li>}
        {msg2 && <li>{replace(msg2, "•", "")}</li>}
        {msg3 && <li>{replace(msg3, "•", "")}</li>}
      </ul>
    </>
  );
};

const OurMission = () => {
  const { data, isFetching, isError } = useGetResponse("mission");

  return (
    <Page
      isLoading={isFetching || isError}
      pageTitle={translationText.OurMission}
    >
      <Container
        id="our-mission"
        style={{ fontSize: "1.5rem", padding: "30px" }}
      >
        {map(
          sortBy(data?.rol?.data, (x) => x.id),
          (mission, index) => (
            <RenderMission key={index} data={mission} />
          )
        )}
      </Container>
    </Page>
  );
};

export default OurMission;
